module.exports = __webpack_public_path__ + "3108a026bcafcb05c6696264b0ade9b1.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/videos/lifeQuestionQ3.mp4
// module id = 412
// module chunks = 0